// openEHR LANG model — BMM package org.openehr.lang.beom.types
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import * as openehr_base from "../../base/mod.ts";

/**
 * Ancestor class for type definitions known in the openEHR Expression formalism.
 */
export abstract class EXPR_TYPE_DEF {
  /**
   * Internal storage for type_name
   * @protected
   */
  protected _type_name?: openehr_base.String;

  /**
   * Natural language type name of this type as used in abstract rules syntax variable declarations.
   */
  get type_name(): string | undefined {
    return this._type_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for type_name.
   * Use this to access openehr_base.String methods.
   */
  get $type_name(): openehr_base.String | undefined {
    return this._type_name;
  }

  /**
   * Sets type_name from either a primitive value or openehr_base.String wrapper.
   */
  set type_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._type_name = undefined;
    } else if (typeof val === "string") {
      this._type_name = openehr_base.String.from(val);
    } else {
      this._type_name = val;
    }
  }

  /**
   * Attribute of the openEHR primitive type (or Any) corresponding to this type definition meta-type.
   */
  type_anchor?: openehr_base.Any;
}

/**
 * Rules meta-type representing the primitive type Boolean.
 */
export class TYPE_DEF_BOOLEAN extends EXPR_TYPE_DEF {
  override get type_name(): string | undefined {
    return this._type_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for type_name.
   * Use this to access openehr_base.String methods.
   */
  override get $type_name(): openehr_base.String | undefined {
    return this._type_name;
  }

  /**
   * Sets type_name from either a primitive value or openehr_base.String wrapper.
   */
  override set type_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._type_name = undefined;
    } else if (typeof val === "string") {
      this._type_name = openehr_base.String.from(val);
    } else {
      this._type_name = val;
    }
  }

  override type_anchor?: openehr_base.Boolean = undefined;
}

/**
 * Rules meta-type representing the primitive type Date.
 */
export class TYPE_DEF_DATE extends EXPR_TYPE_DEF {
  override get type_name(): string | undefined {
    return this._type_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for type_name.
   * Use this to access openehr_base.String methods.
   */
  override get $type_name(): openehr_base.String | undefined {
    return this._type_name;
  }

  /**
   * Sets type_name from either a primitive value or openehr_base.String wrapper.
   */
  override set type_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._type_name = undefined;
    } else if (typeof val === "string") {
      this._type_name = openehr_base.String.from(val);
    } else {
      this._type_name = val;
    }
  }

  override type_anchor?: openehr_base.Iso8601_date = undefined;
}

/**
 * Rules meta-type representing the primitive type Date_time.
 */
export class TYPE_DEF_DATE_TIME extends EXPR_TYPE_DEF {
  override get type_name(): string | undefined {
    return this._type_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for type_name.
   * Use this to access openehr_base.String methods.
   */
  override get $type_name(): openehr_base.String | undefined {
    return this._type_name;
  }

  /**
   * Sets type_name from either a primitive value or openehr_base.String wrapper.
   */
  override set type_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._type_name = undefined;
    } else if (typeof val === "string") {
      this._type_name = openehr_base.String.from(val);
    } else {
      this._type_name = val;
    }
  }

  override type_anchor?: openehr_base.Iso8601_date_time = undefined;
}

/**
 * Rules meta-type representing the primitive type Duration.
 */
export class TYPE_DEF_DURATION extends EXPR_TYPE_DEF {
  override get type_name(): string | undefined {
    return this._type_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for type_name.
   * Use this to access openehr_base.String methods.
   */
  override get $type_name(): openehr_base.String | undefined {
    return this._type_name;
  }

  /**
   * Sets type_name from either a primitive value or openehr_base.String wrapper.
   */
  override set type_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._type_name = undefined;
    } else if (typeof val === "string") {
      this._type_name = openehr_base.String.from(val);
    } else {
      this._type_name = val;
    }
  }

  override type_anchor?: openehr_base.Iso8601_duration = undefined;
}

/**
 * Rules meta-type representing the primitive type Integer.
 */
export class TYPE_DEF_INTEGER extends EXPR_TYPE_DEF {
  override get type_name(): string | undefined {
    return this._type_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for type_name.
   * Use this to access openehr_base.String methods.
   */
  override get $type_name(): openehr_base.String | undefined {
    return this._type_name;
  }

  /**
   * Sets type_name from either a primitive value or openehr_base.String wrapper.
   */
  override set type_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._type_name = undefined;
    } else if (typeof val === "string") {
      this._type_name = openehr_base.String.from(val);
    } else {
      this._type_name = val;
    }
  }

  override type_anchor?: openehr_base.Integer = undefined;
}

/**
 * Rules meta-type representing the type Object_ref, which is assumed to by the type of any non-primitive reference target within a rule.
 */
export class TYPE_DEF_OBJECT_REF extends EXPR_TYPE_DEF {
  override get type_name(): string | undefined {
    return this._type_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for type_name.
   * Use this to access openehr_base.String methods.
   */
  override get $type_name(): openehr_base.String | undefined {
    return this._type_name;
  }

  /**
   * Sets type_name from either a primitive value or openehr_base.String wrapper.
   */
  override set type_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._type_name = undefined;
    } else if (typeof val === "string") {
      this._type_name = openehr_base.String.from(val);
    } else {
      this._type_name = val;
    }
  }
}

/**
 * Rules meta-type representing the primitive type Real.
 */
export class TYPE_DEF_REAL extends EXPR_TYPE_DEF {
  override get type_name(): string | undefined {
    return this._type_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for type_name.
   * Use this to access openehr_base.String methods.
   */
  override get $type_name(): openehr_base.String | undefined {
    return this._type_name;
  }

  /**
   * Sets type_name from either a primitive value or openehr_base.String wrapper.
   */
  override set type_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._type_name = undefined;
    } else if (typeof val === "string") {
      this._type_name = openehr_base.String.from(val);
    } else {
      this._type_name = val;
    }
  }

  override type_anchor?: openehr_base.Real = undefined;
}

/**
 * Rules meta-type representing the primitive type String.
 */
export class TYPE_DEF_STRING extends EXPR_TYPE_DEF {
  override get type_name(): string | undefined {
    return this._type_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for type_name.
   * Use this to access openehr_base.String methods.
   */
  override get $type_name(): openehr_base.String | undefined {
    return this._type_name;
  }

  /**
   * Sets type_name from either a primitive value or openehr_base.String wrapper.
   */
  override set type_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._type_name = undefined;
    } else if (typeof val === "string") {
      this._type_name = openehr_base.String.from(val);
    } else {
      this._type_name = val;
    }
  }

  override type_anchor?: openehr_base.String = undefined;
}

/**
 * Rules meta-type representing the primitive type Terminology_code.
 */
export class TYPE_DEF_TERMINOLOGY_CODE extends EXPR_TYPE_DEF {
  override get type_name(): string | undefined {
    return this._type_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for type_name.
   * Use this to access openehr_base.String methods.
   */
  override get $type_name(): openehr_base.String | undefined {
    return this._type_name;
  }

  /**
   * Sets type_name from either a primitive value or openehr_base.String wrapper.
   */
  override set type_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._type_name = undefined;
    } else if (typeof val === "string") {
      this._type_name = openehr_base.String.from(val);
    } else {
      this._type_name = val;
    }
  }

  override type_anchor?: openehr_base.Terminology_code = undefined;
}

/**
 * Rules meta-type representing the primitive type Time.
 */
export class TYPE_DEF_TIME extends EXPR_TYPE_DEF {
  override get type_name(): string | undefined {
    return this._type_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for type_name.
   * Use this to access openehr_base.String methods.
   */
  override get $type_name(): openehr_base.String | undefined {
    return this._type_name;
  }

  /**
   * Sets type_name from either a primitive value or openehr_base.String wrapper.
   */
  override set type_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._type_name = undefined;
    } else if (typeof val === "string") {
      this._type_name = openehr_base.String.from(val);
    } else {
      this._type_name = val;
    }
  }

  override type_anchor?: openehr_base.Iso8601_time = undefined;
}

/**
 * Rules meta-type representing the primitive type Uri.
 */
export class TYPE_DEF_URI extends EXPR_TYPE_DEF {
  override get type_name(): string | undefined {
    return this._type_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for type_name.
   * Use this to access openehr_base.String methods.
   */
  override get $type_name(): openehr_base.String | undefined {
    return this._type_name;
  }

  /**
   * Sets type_name from either a primitive value or openehr_base.String wrapper.
   */
  override set type_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._type_name = undefined;
    } else if (typeof val === "string") {
      this._type_name = openehr_base.String.from(val);
    } else {
      this._type_name = val;
    }
  }

  override type_anchor?: openehr_base.Uri = undefined;
}
